import { useContext } from "react";

import appContext from "../context/appContext";
import { actions } from "../context/AppProvider";

import GeoList from "../../../components/HeEPS/GeoList";

const LeftPane = () => {
    const { state, dispatch } = useContext(appContext);

    if (state.selectedGeos.length === 0) {
        return (
            <div
                style={{
                    padding: "5px 0 10px 10px",
                    borderTop: "1px solid lightgrey",
                    borderBottom: "1px solid lightgrey",
                }}
            >
                <i>Select one or more counties to generate a report.</i>
            </div>
        );
    }
    return (
        <div
            style={{
                padding: "5px 0 10px 10px",
                borderTop: "1px solid lightgrey",
                borderBottom: "1px solid lightgrey",
            }}
        >
            <div style={{ display: "grid", gridTemplateColumns: "auto 80px", marginBottom: 5 }}>
                <div style={{ color: "#0B446B" }}>COUNTIES</div>
                <button className="resetBtn" onClick={() => dispatch({ type: actions.CLEAR_GEOS })}>
                    Reset
                </button>
            </div>
            <GeoList
                selectedGeos={state.selectedGeos}
                dataAlerts={[]}
                removeGeo={(geoId) => {
                    dispatch({ type: actions.REMOVE_GEO, id: geoId });
                }}
                onMouseEnter={(id) => {
                    dispatch({ type: actions.SET_HIGHLIGHTED_GEO, to: id });
                }}
                onMouseLeave={(id) => {
                    dispatch({ type: actions.SET_HIGHLIGHTED_GEO, to: null });
                }}
            />
        </div>
    );
};
export default LeftPane;
